<div class="missed-call-detail-container" *ngIf="isReady() && data">
  <div class="col-left"
    [innerHTML]="'missed_call.call_detail.missed_call_reason'|translate:{ reason: missed_call_reason }">
  </div>
  <div class="col-right"
    [innerHTML]="'missed_call.call_detail.agent_list'|translate:{agent_names: agent_names.join('; ')}">
  </div>
</div>
